// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tabs_trip-desc-container__KmYo1{
    width: 85vw;
    min-height: 40vw;
    height: auto;
    border-radius: 2vw;
    margin-left: 7.5vw;
    margin-top: -15vw;
}

.Tabs_mobile-tabs__UwoTM{
    display: none;
}

.Tabs_tabs-container__fjWLf{
    display: flex;
    flex-direction: row;
    margin-bottom: 1vw;
}



.Tabs_tabs-button__lcNPT{
    width: auto;
    padding-left: 1vw;
    padding-right: 1vw;
    height: 3vw;
    font-size: 1.3vw;
    background-color: white;
    border: 1px solid black;
    border-radius: 100vw;
    margin-right: 0.5vw;
    cursor: pointer;
}

.Tabs_tabs-data-container__M5Z2u{
    width: 85vw;
    min-height: 40vw;
    height: auto;
    border: 1px solid black;
    border-radius: 1vw;
    background-color: white;
}

@media(max-width: 768px){
    .Tabs_trip-desc-container__KmYo1{
        width: 90vw;
        min-height: 40vw;
        height: auto;
        border-radius: 2vw;
        margin-left: 5vw;
        margin-top: 120vw;
        margin-bottom: 10vw;
    }

    .Tabs_mobile-tabs__UwoTM{
        display: block;
    }
    
    .Tabs_tabs-container__fjWLf{
        display: flex;
        flex-direction: column;
        margin-bottom: 1vw;
    }
    
    .Tabs_tabs-button__lcNPT{
        width: auto;
        padding-left: 1vw;
        padding-right: 1vw;
        height: 12vw;
        font-size: 5vw;
        background-color: #e65439;
        color: white;
        font-weight: 600;
        border: 0px solid black;
        border-radius: 3vw;
        margin-right: 0vw;
        cursor: pointer;
        margin-bottom: 3vw;
    }
    
    .Tabs_tabs-data-container__M5Z2u{
        display: none;
        width: 85vw;
        min-height: 40vw;
        height: auto;
        border: 1px solid black;
        border-radius: 1vw;
        background-color: white;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SingleTripPage/Tabs/Tabs.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;;;AAIA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,cAAc;QACd,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;QACvB,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,uBAAuB;QACvB,kBAAkB;QAClB,uBAAuB;IAC3B;AACJ","sourcesContent":[".trip-desc-container{\n    width: 85vw;\n    min-height: 40vw;\n    height: auto;\n    border-radius: 2vw;\n    margin-left: 7.5vw;\n    margin-top: -15vw;\n}\n\n.mobile-tabs{\n    display: none;\n}\n\n.tabs-container{\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 1vw;\n}\n\n\n\n.tabs-button{\n    width: auto;\n    padding-left: 1vw;\n    padding-right: 1vw;\n    height: 3vw;\n    font-size: 1.3vw;\n    background-color: white;\n    border: 1px solid black;\n    border-radius: 100vw;\n    margin-right: 0.5vw;\n    cursor: pointer;\n}\n\n.tabs-data-container{\n    width: 85vw;\n    min-height: 40vw;\n    height: auto;\n    border: 1px solid black;\n    border-radius: 1vw;\n    background-color: white;\n}\n\n@media(max-width: 768px){\n    .trip-desc-container{\n        width: 90vw;\n        min-height: 40vw;\n        height: auto;\n        border-radius: 2vw;\n        margin-left: 5vw;\n        margin-top: 120vw;\n        margin-bottom: 10vw;\n    }\n\n    .mobile-tabs{\n        display: block;\n    }\n    \n    .tabs-container{\n        display: flex;\n        flex-direction: column;\n        margin-bottom: 1vw;\n    }\n    \n    .tabs-button{\n        width: auto;\n        padding-left: 1vw;\n        padding-right: 1vw;\n        height: 12vw;\n        font-size: 5vw;\n        background-color: #e65439;\n        color: white;\n        font-weight: 600;\n        border: 0px solid black;\n        border-radius: 3vw;\n        margin-right: 0vw;\n        cursor: pointer;\n        margin-bottom: 3vw;\n    }\n    \n    .tabs-data-container{\n        display: none;\n        width: 85vw;\n        min-height: 40vw;\n        height: auto;\n        border: 1px solid black;\n        border-radius: 1vw;\n        background-color: white;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trip-desc-container": `Tabs_trip-desc-container__KmYo1`,
	"mobile-tabs": `Tabs_mobile-tabs__UwoTM`,
	"tabs-container": `Tabs_tabs-container__fjWLf`,
	"tabs-button": `Tabs_tabs-button__lcNPT`,
	"tabs-data-container": `Tabs_tabs-data-container__M5Z2u`
};
export default ___CSS_LOADER_EXPORT___;
